import Register from '../../pages/register'

export default {
  path: 'register',
  component: Register,
}



// WEBPACK FOOTER //
// ./src/routes/Register/index.js